import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { EventTypeService } from '../../../../../../../../services/event-type/event-type.service';

@Component({
  selector: 'app-preview-waitlist-confirmation-email-modal',
  templateUrl: './preview-waitlist-confirmation-email-modal.component.html',
  styleUrls: ['./preview-waitlist-confirmation-email-modal.component.css']
})
export class PreviewWaitlistConfirmationEmailModalComponent implements OnInit {
  @Input() eventTypeId: number;
  @Input() waitlistConfirmationEmailText: string;

  public loading = false;
  public errorMessage = '';

  public subject = '';
  public htmlContent = '';

  constructor(
    public activeModal: NgbActiveModal,
    private eventTypeService: EventTypeService
  ) {}

  ngOnInit() {
    this.loading = true;

    this.eventTypeService
      .previewWaitlistConfirmationEmail(
        this.eventTypeId,
        this.waitlistConfirmationEmailText
      )
      .then(preview => {
        this.subject = preview.subject;
        this.htmlContent = preview.html_content;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to preview this email.';
        } else {
          this.errorMessage = 'Failed to load email preview.';
        }
      })
      .finally(() => { this.loading = false; });
  }
}
